var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.4999 0.511719C16.0228 0.511719 20.4999 4.98887 20.4999 10.5117C20.4999 16.0346 16.0228 20.5117 10.4999 20.5117C4.97709 20.5117 0.499939 16.0346 0.499939 10.5117C0.499939 4.98887 4.97709 0.511719 10.4999 0.511719ZM10.4999 2.01172C5.80552 2.01172 1.99994 5.8173 1.99994 10.5117C1.99994 15.2061 5.80552 19.0117 10.4999 19.0117C15.1944 19.0117 18.9999 15.2061 18.9999 10.5117C18.9999 5.8173 15.1944 2.01172 10.4999 2.01172ZM10.4999 5.51172C10.9142 5.51172 11.2499 5.84751 11.2499 6.26172V9.76172H14.7499C15.1642 9.76172 15.4999 10.0975 15.4999 10.5117C15.4999 10.9259 15.1642 11.2617 14.7499 11.2617H11.2499V14.7617C11.2499 15.1759 10.9142 15.5117 10.4999 15.5117C10.0857 15.5117 9.74994 15.1759 9.74994 14.7617V11.2617H6.24994C5.83573 11.2617 5.49994 10.9259 5.49994 10.5117C5.49994 10.0975 5.83573 9.76172 6.24994 9.76172H9.74994V6.26172C9.74994 5.84751 10.0857 5.51172 10.4999 5.51172Z",
    fill: "#475569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/Add_circle.7f88e6e5da5403dbe3a66cf9f6f4bef2.svg";
export { ForwardRef as ReactComponent };